// Links in notification emails point at protected pages - the recruiter's
// applicant list for a job, the hiring manager's applicants panel. Opening one
// in a browser with no live session hits ProtectedRoute, which used to
// `Navigate` to the landing page and drop the destination, so the link looked
// broken. The intended path is parked here instead and honoured once the user
// is signed in. localStorage, not state, because OAuth is a full-page redirect.
const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

// Only in-app paths, never absolute URLs or protocol-relative ones - a stored
// "//evil.example" or "https://…" would turn a sign-in into an open redirect.
const isSafeInAppPath = (path: string) =>
  path.startsWith("/") && !path.startsWith("//");

export const savePostLoginRedirect = (path: string) => {
  if (!path || !isSafeInAppPath(path)) return;
  // The landing page and the signup screens are where we send people to sign in;
  // remembering them would just bounce the user back to where they started.
  if (path === "/" || path.startsWith("/finishSignup") || path.startsWith("/signin")) return;
  localStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

export const clearPostLoginRedirect = () =>
  localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

/** Returns the parked path once and forgets it, or null if there isn't one. */
export const takePostLoginRedirect = (): string | null => {
  const path = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  clearPostLoginRedirect();
  return path && isSafeInAppPath(path) ? path : null;
};
